import { useState } from 'react'
import styled, { useTheme } from 'styled-components'
import FlatIcon from '@/components/common/icons/FlatIcon'
import { Typo } from '@/components/common/typography'
import { IconNameEnum } from '@/constants/icon-name.enum'
import { IconSizeEnum } from '@/constants/icon-size.enum'
import { UserContainer } from '@/containers/users/UserContainer'
import { formatPhoneNumber } from '@/utils/utilString'

export const UserInfoSection = () => {
  const { me } = UserContainer.useContainer()
  const { color } = useTheme()
  const [isOpen, setIsOpen] = useState<boolean>(false)

  const handleToggle = () => {
    setIsOpen((prevState) => !prevState)
  }

  return (
    <>
      <StyledSectionTitle onClick={handleToggle}>
        <Typo variant={'Body1 Bold'}>주문자 정보</Typo>
        <FlatIcon type={isOpen ? IconNameEnum.IcArrowUp : IconNameEnum.IcArrowDown} size={IconSizeEnum.Size24} />
      </StyledSectionTitle>
      {isOpen && (
        <StyledSectionUserInfo>
          <Typo variant="Body3 Regular">
            {`${me?.name} (${formatPhoneNumber(me?.mobileNumber || '')})`}
            <br />
            {me?.email}
          </Typo>
          <Typo variant="Body4 Regular" color={color.gray400}>
            {`*주문자 정보는 마이페이지 > 내정보 에서 변경가능합니다.`}
          </Typo>
        </StyledSectionUserInfo>
      )}
    </>
  )
}

const StyledSectionTitle = styled.div`
  height: 4.8rem;
  padding: 1.2rem 1.6rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
`

const StyledSectionUserInfo = styled.div`
  padding: 0 1.6rem 2rem;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
`
